import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface CondicionesOperacionPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface CondicionesOperacion {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface CondicionesOperacionResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class CondicionesOperacionService {
  private readonly apiUrl = `${environment.apiUrl}/api/condiciones_operacion`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todas las condiciones de operación
   */
  getAll(): Observable<CondicionesOperacion[]> {
    return this.http.get<CondicionesOperacion[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  /**
   * Obtener condición de operación por ID
   */
  getById(id: number): Observable<CondicionesOperacion> {
    return this.http.get<CondicionesOperacion>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear condición de operación
   */
  create(
    payload: CondicionesOperacionPayload
  ): Observable<CondicionesOperacionResponse> {
    return this.http.post<CondicionesOperacionResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar condición de operación
   */
  update(
    id: number,
    payload: Partial<CondicionesOperacionPayload>
  ): Observable<CondicionesOperacionResponse> {
    return this.http.put<CondicionesOperacionResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar condición de operación
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar condición de operación
   */
  inactivar(id: number): Observable<CondicionesOperacionResponse> {
    return this.http.put<CondicionesOperacionResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar condición de operación
   */
  activar(id: number): Observable<CondicionesOperacionResponse> {
    return this.http.put<CondicionesOperacionResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}